module.exports = __webpack_public_path__ + "img/vip-special-qrcode.5206a7f9.png";